import api from './api';

// Plant Categories
const getPlantCategories = () => api.get('/plant/categories/');
const getPlantCategory = (categoryId) => api.get(`/plant/categories/${categoryId}/`);
const createPlantCategory = (data) => api.post('/plant/categories/', data);
const updatePlantCategory = (categoryId, data) => api.put(`/plant/categories/${categoryId}/`, data);
const deletePlantCategory = (categoryId) => api.delete(`/plant/categories/${categoryId}/`);

// Plants
const getPlants = () => api.get('/plant/plants/');
const getPlant = (plantId) => api.get(`/plant/plants/${plantId}/`);
const addPlant = (data) => api.post('/plant/plants/', data);
const updatePlant = (plantId, data) => api.put(`/plant/plants/${plantId}/`, data);
const deletePlant = (plantId) => api.delete(`/plant/plants/${plantId}/`);

export {
    getPlantCategories,
    getPlantCategory,
    createPlantCategory,
    updatePlantCategory,
    deletePlantCategory,
    getPlants,
    getPlant,
    addPlant,
    updatePlant,
    deletePlant,
};
